/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Station } from '../../models/station';

export interface GetStation$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
}

export function getStation(http: HttpClient, rootUrl: string, params: GetStation$Params, context?: HttpContext): Observable<StrictHttpResponse<Station>> {
  const rb = new RequestBuilder(rootUrl, getStation.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Station>;
    })
  );
}

getStation.PATH = '/stations/{uid}';
